import { Component, OnInit } from '@angular/core';
import {AngularFireDatabase, AngularFireList} from '@angular/fire/database';
import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {PredictedSignal} from '../predicted-signal.model';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-test-with-another-algorithm',
  templateUrl: './test-with-another-algorithm.component.html',
  styleUrls: ['./test-with-another-algorithm.component.scss']
})
export class TestWithAnotherAlgorithmComponent implements OnInit {
  headElements = ['Reference Number', 'GH-EFDT', 'OnlineSMOTEBaggingClassifier', 'OnlineUnderOverBaggingClassifier', 'Verification', 'True Class'];

  constructor(private db: AngularFireDatabase, private apiService: ApiService) {
  }
  itemsRef: AngularFireList<any>;
  items: Observable<PredictedSignal[]>;

  ngOnInit(): void {
    this.itemsRef = this.db.list('asips-3efdd-default-rtdb/Predictions');
    // Use snapshotChanges().map() to store the key
    this.items = this.itemsRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
      )
    );
    this.items.subscribe(result => {
      console.log(result.length);
      if (result.length === 0){
        this.confirm_accuracy();
      }
    });
  }

  verifyItemCorrect(key: string) {
    this.apiService.learn(key)
      .subscribe(data => {
          console.log(data.message);
          // this.logText[this.logText.length] = data.message;
        },
        error => {
          // this.logText[this.logText.length]  = error.message;
          console.error('There was an error!', error);
        });
  }

  verifyItemWrong(key: string) {
    this.apiService.learn(key)
      .subscribe(data => {
          console.log(data.message);
          // this.logText[this.logText.length] = data.message;
        },
        error => {
          // this.logText[this.logText.length]  = error.message;
          console.error('There was an error!', error);
        });
  }
  testWithOtherClassifier(model) {
    this.apiService.testWithOtherClassifier(model)
      .subscribe(data => {
          console.log(data.message);
        },
        error => {
          console.error('There was an error!', error);
        });
  }
  private confirm_accuracy() {
    const measuresRef = this.db.list('asips-3efdd-default-rtdb');
    measuresRef.update('CurrentEvaluationMeasures', { confirmationState: 1 });
    measuresRef.update('CurrentMeanEvaluationMeasures', { confirmationState: 1 });
  }
}
